import builder from '../builder';
import CalendarBlock from '../../streamline-icons/light/calendar-block.svg';

export default builder('IconCalendarBlock', CalendarBlock);
